module.exports = __webpack_public_path__ + "img/vignettes-asso_0002_les-funambules.4800c28b.jpg";